module.exports = __webpack_public_path__ + "fonts/Heebo-Medium.6c57263d.ttf";